export const CHECKOUT_URL = 'https://prenatal-fitness-coach-pro.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offer'

export const PRODUCT_NAME = 'PRENATAL FITNESS COACH PRO™'

export const PRODUCT_TAGLINE = 'THE COMPLETE PROFESSIONAL COACHING SYSTEM'

export const PRODUCT_SUBTITLE =
  'The Ready-to-Use System to Assess, Plan, Adapt & Coach Prenatal Fitness Clients'

export const PRODUCT_IMG =
  'https://cdn.magicpatterns.com/uploads/7aqk9BiRPic9Pg9kzYbceL/Diseno-sin-titulo-4-2.webp'

export const PRODUCT_ALT =
  'PRENATAL FITNESS COACH PRO™ — complete 6-in-1 prenatal fitness coaching system box set'

export const PRICE_FULL = '$97'

export const PRICE_TODAY = '$27'

export const SUPPORT_EMAIL = 'kitonline27@gmail.com'

export const PIXEL_ID = '1733329941053749'
